import React, { useState, Fragment, useEffect } from "react";
import { Col, Form, Row, Radio, Modal, message } from "antd";
import {
  GUTTER_MD,
  MARGIN_MD,
  MARGIN_XS,
  SPAN_FULL,
} from "../../../styles/constants";
import Selector from "../../../components/selector";
import { getStringFromArtefactTriplet } from "../../../utils/sdmxJson";
import { userMustNotInsertTid } from "./csv-form/utils";
import { translate } from "react-i18next";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  readLoaderCCs,
  setLoaderCC,
  setLoaderCCFile,
  checkLoaderCcValidationFile,
} from "./actions";
import FileInput from "../../../components/file-input";

const mapStateToProps = (state) => ({
  appLanguage: state.app.language,
  format: state.scenes.dataManager.loader.shared.format,
  cubeId: state.scenes.dataManager.loader.components.xmlForm.local.cubeId,
  cube: state.scenes.dataManager.loader.components.xmlForm.shared.cube,
  mappingId:state.scenes.dataManager.loader.components.csvForm.shared.mappingId,
  mapping: state.scenes.dataManager.loader.components.csvForm.shared.mapping,
  mappingCube:state.scenes.dataManager.loader.components.csvForm.shared.mappingCube,
  tid: state.scenes.dataManager.loader.components.csvForm.shared.tid,
  file: state.scenes.dataManager.loader.components.csvForm.local.file,
  cc: state.scenes.dataManager.loader.shared.cc,
  ccFile: state.scenes.dataManager.loader.shared.ccFile,
  ccFileServerPath: state.scenes.dataManager.loader.shared.ccFileServerPath,
  ccData: state.scenes.dataManager.loader.shared.ccData,
});

const mapDispatchToProps = (dispatch) => ({
  onCcValidationUpload: (file) => dispatch(checkLoaderCcValidationFile(file)),
  fetchCCs: (cubeId) => dispatch(readLoaderCCs(cubeId)),
  onCCSet: (ccTriplet) => dispatch(setLoaderCC(ccTriplet)),
  onCCFileSet: (ccFile) => dispatch(setLoaderCCFile(ccFile)),
});

const CcPicker = ({
  t,
  format,
  mappingId,
  mapping,
  mappingCube,
  tid,
  cubeId,
  cube,
  cc,
  fetchCCs,
  onCCSet,
  ccData,
  ccFile,
  ccFileServerPath,
  onCcValidationUpload,
  onCCFileSet,
}) => {
  message.config({
    duration: 3,
    maxCount: 1,
  });

  const [ccValidation, setCcValidation] = useState("msdb");

  useEffect(
    () => {
      if (ccFile && !ccFileServerPath) {
        onCcValidationUpload(ccFile);
      }
    },
    [ccFile]
  );

  useEffect(
    () => {
      if (ccData !== null) {
        if (ccData === 0) {
          Modal.error({
            title: t("scenes.dataManager.loader.modals.error.title"),
            content: t("scenes.dataManager.loader.modals.error.content"),
            onOk() {
              onCCFileSet(null);
            },
            onCancel() {
              onCCFileSet(null);
            },
          });
        } else if (ccData !== 1) {
          message.warn(t("scenes.dataManager.loader.modals.warning.content"));
        } else {
          message.success(t("scenes.dataManager.loader.modals.sucess.content"));
        }
      }
    },
    [ccData]
  );
  return (
    <Fragment>
      <Row type="flex" style={{ marginBottom: MARGIN_XS }}>
        <Col>
          <Form.Item
            label={t("scenes.dataManager.loader.csvForm.fields.cc.label")}
          >
            <Radio.Group
              defaultValue="msdb"
              onChange={({ target }) => {
                setCcValidation(target.value);
                onCCFileSet(null);
                onCCSet(null);
              }}
            >
              <Radio.Button value="msdb">MSDB</Radio.Button>
              <Radio.Button value="sdmx-ml">SDMX-ML File</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
        <Col span={SPAN_FULL}>
          <Form.Item defaultValue={null}>
            {ccValidation === "msdb" ? (
              <Selector
                disabled={
                  format !== "sdmx-ml"
                    ? mappingId === null ||
                      (!userMustNotInsertTid(mapping, mappingCube) &&
                        (tid === null || tid.length === 0))
                    : cube === null
                }
                selectTitle={t("scenes.dataManager.loader.csvForm.fields.cc.selectTitle")}
                resetTitle={t("scenes.dataManager.loader.csvForm.fields.cc.resetTitle")}
                onSelect={() =>
                  fetchCCs(format !== "sdmx-ml" ? mappingCube.IDCube : cubeId)
                }
                onReset={() => onCCSet(null)}
                value={cc ? getStringFromArtefactTriplet(cc) : null}
              />
            ) : (
              <FileInput
                value={ccFile}
                disabled={
                  format !== "sdmx-ml"
                    ? mappingId === null ||
                      (!userMustNotInsertTid(mapping, mappingCube) &&
                        (tid === null || tid.length === 0))
                    : cube === null
                }
                accept={".xml"}
                onChange={onCCFileSet}
                isZipAllowed
              />
            )}
          </Form.Item>
        </Col>
      </Row>
    </Fragment>
  );
};

export default compose(
  translate(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CcPicker);
